// src/components/Admin/UserManager/index.jsx
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from '@mui/material';

// 아이콘
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import GroupIcon from '@mui/icons-material/Group';
import PaidIcon from '@mui/icons-material/Paid';

import UserList from './UserList';
import PointLogs from './PointLogs';
import { useUser } from '../../../contexts/UserContext';

export default function UserManagerPage() {
  const { userInfo } = useUser();
  const [tab, setTab] = useState(0);
  const handleTabChange = (_, newValue) => setTab(newValue);

  if (!userInfo) return null;

  return (
    <Box
      sx={{
        p: 4,
        /* 모바일: 90 % 축소 & 좌상단 기준 */
        '@media (max-width:600px)': {
          transform: 'scale(0.9)',
          transformOrigin: 'top left',
          p: 2,
        },
      }}
    >
      {/* 타이틀 */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
        <ManageAccountsIcon sx={{ fontSize: '2rem' }} />
        <Typography
          variant="h4"
          sx={{
            fontWeight: 'bold',
            '@media (max-width:600px)': { fontSize: '1.5rem' },
          }}
        >
          회원 관리
        </Typography>
      </Box>

      {/* 본탭: 배경 강조 */}
      <Paper
        elevation={2}
        sx={{
          mb: 3,
          borderRadius: 2,
          backgroundColor: '#f5f5f5',
          px: 2,
          '@media (max-width:600px)': { px: 1 },
        }}
      >
        <Tabs
          value={tab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          variant="fullWidth"
          sx={{
            '& .MuiTab-root': {
              minHeight: 48,
              '@media (max-width:600px)': {
                minHeight: 40,
                fontSize: '0.8rem',
              },
            },
          }}
        >
          <Tab
            icon={<GroupIcon />}
            iconPosition="start"
            label="회원 목록"
          />
          <Tab
            icon={<PaidIcon />}
            iconPosition="start"
            label="전체 포인트(Leaf) 로그"
          />
        </Tabs>
      </Paper>

      {/* 콘텐츠 */}
      {tab === 0 && <UserList userInfo={userInfo} />}
      {tab === 1 && <PointLogs />}
    </Box>
  );
}
